// extracted by mini-css-extract-plugin
export var fullheight = "style-module--fullheight--4J0TT";
export var container = "style-module--container--IGeGO";
export var fadeIn = "style-module--fadeIn--m3gpl";
export var wide = "style-module--wide--wCmYc";
export var header_main = "style-module--header_main--mhCZb";
export var logo_link = "style-module--logo_link--V6l99";
export var logo_img = "style-module--logo_img--XlMC+";
export var links_link = "style-module--links_link---GvWU";
export var links_desktop = "style-module--links_desktop--01rXD";
export var links_menu = "style-module--links_menu--4lzkr";
export var links_menu_open = "style-module--links_menu_open--4AWY4";
export var links_menu_close = "style-module--links_menu_close--E8SO0";
export var links_menu_hamburger = "style-module--links_menu_hamburger--0sg9f";
export var links_menu_hamburger__line = "style-module--links_menu_hamburger__line--5A8ZQ";
export var open = "style-module--open--zVC3R";
export var close = "style-module--close--jaUnW";
export var iconlinks = "style-module--iconlinks--lbtiv";
export var copyright = "style-module--copyright--vbxHN";